import { FlaskConical } from "lucide-react-native";
import { useTranslations } from "@src/packages/i18n";
import { Dialog, DialogHeader } from "@louise/moon-ui";
import { EMBER } from "../../onboarding/theme";
import { EVIDENCE_LEVELS } from "./EvidenceLevelChip";

export default function EvidenceLevelModal({
  level,
  visible,
  onClose,
}: {
  level: string | null;
  visible: boolean;
  onClose: () => void;
}) {
  const t = useTranslations();
  if (!level) return null;
  const info = EVIDENCE_LEVELS[level];
  if (!info) return null;

  return (
    <Dialog
      visible={visible}
      onClose={onClose}
      closeButton="minimal"
      closeAccessibilityLabel={t("learn.article_actions.close_accessibility")}
      closeAction="close_evidence_level"
      backdropPressLabel="dismiss_evidence_level_backdrop"
    >
      <DialogHeader
        leading={
          <FlaskConical
            size={22}
            color={EMBER.colors.textMid}
            strokeWidth={1.6}
          />
        }
        title={t(`learn.evidence_levels.${info.i18nKey}.label`)}
        subtitle={t(`learn.evidence_levels.${info.i18nKey}.description`)}
      />
    </Dialog>
  );
}
